import React from 'react';

type NavigationItemProps = { children: React.ReactNode, className?: string };

export const NavigationItem = ({ children, className = '' }: NavigationItemProps) => (
  <li className={`AppHeader__navigationItem tc1 fs17 fw500 ${className}`}>
    <div className="AppHeader__navigationItemText">
      {children}
    </div>
  </li>
);
